var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareBranch = function SvgShareBranch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24292D",
    d: "M10.897 2a2.075 2.075 0 1 1-1.503 3.504L6.114 7.64a2.085 2.085 0 0 1 .002.75l3.282 2.136a2.075 2.075 0 1 1-.497.87L5.697 9.31a2.075 2.075 0 1 1-.004-2.59L8.9 4.632a2.078 2.078 0 0 1 1.998-2.631zm0 8.885a1.075 1.075 0 1 0 .001 2.15 1.075 1.075 0 0 0 0-2.15zM4.074 6.943a1.074 1.074 0 1 0 0 2.149 1.074 1.074 0 0 0 0-2.149zm6.823-3.942a1.074 1.074 0 1 0 .001 2.148 1.074 1.074 0 0 0 0-2.148z"
  })));
};
export default SvgShareBranch;